"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  name: 'SectorsTable',
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete', 'edit'],
  computed: {
    tableData: function tableData() {
      return Array.isArray(this.data) ? this.data : [];
    }
  },
  methods: {
    formatRows: function formatRows(rows) {
      if (!Array.isArray(rows) || !rows.length) return '--';
      var names = rows.map(function (row) {
        return row === null || row === void 0 ? void 0 : row.name;
      }).filter(Boolean);
      return names.length ? names.join(', ') : '--';
    }
  }
};